/**
 * useMissionHistoryData Hook
 * 
 * Provides stats and missions data for Mission History page
 */

import { useMemo } from 'react';
import { MISSION_STATS_DATA, RECENT_MISSIONS_DATA } from '../constants';

export const useMissionHistoryData = () => {
    const stats = useMemo(() => MISSION_STATS_DATA, []);
    const recentMissions = useMemo(() => RECENT_MISSIONS_DATA, []);

    return {
        stats,
        recentMissions,
    };
};
